/**
 * Step classification for the R-162 continuous-feed cross-batch UX.
 *
 * - FLOW_STEPS: end-of-batch transition shows a brief (3-second) toast.
 * - QC_STEPS: end-of-batch transition shows a confirm modal.
 * - Other steps (scan/classify/export/batch-fix) currently never run in the
 *   feed loop — classified as 'other' so they aren't treated as flow.
 *
 * **Adding a new pipeline step?** Update both arrays here AND add the new
 * step to the `PipelineStep` discriminated union. The classifier silently
 * defaults unknown steps to "other" — a surprise QC step will not get the
 * confirm modal until it's added to QC_STEPS, and a surprise flow step will
 * not get the toast until it's added to FLOW_STEPS.
 *
 * SP3 — remittance step types ('remittance', 'remittance-key',
 * 'remittance-balance') are DELIBERATELY not in FLOW_STEPS/QC_STEPS: they
 * never run in the per-document feed loop (remittance work is batch-claimed
 * via /queues/next's batch variant and worked at /ops/remittance/:batchId),
 * so they classify as 'other' by design, not by omission.
 */
import { QC_STEPS } from "../step-stage.js";
export const FLOW_STEPS = ["key", "verify", "post-ocr"];
// F-039 — pipeline stepType is "qc" (the stage word is "qa"); with only "qa"
// here the QC confirm modal never fired for real qc steps (classified
// "other"). Both words are accepted — same defensive bridging as stageForStep
// in form-config/behaviors.ts. F-024 — moved to step-stage.ts, the canonical
// step↔stage module; re-exported here so existing import sites keep working.
export { QC_STEPS } from "../step-stage.js";
export function classifyTransition(stepType) {
    if (FLOW_STEPS.includes(stepType))
        return "flow";
    if (QC_STEPS.includes(stepType))
        return "qc";
    return "other";
}
//# sourceMappingURL=feed-step-classification.js.map